import { Controller } from "stimulus"
import axios from 'axios';

const maxLength = 280
const separator = '\n[+]\n'
const csrfToken = document.querySelector("meta[name=csrf-token]").content
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

export default class extends Controller {
  static targets = [
    "actionButtons",
    "characterField",
    "chunk",
    "chunkContentField",
    "chunkIndexField",
    "dynamicChunks",
    "notificationField",
    "freeFormContent",
    "loader",
    "originContent",
    "promoChunk",
    "promoChunkContent",
    "promoChunkIndexField",
    "promoSwitcher",
    "scheduleFields",
    "currentTimeZone",
    "editTimeZoneButton",
    "timeZoneField"
  ]

  connect() {
    var ctrl = this
    var urlParams = new URLSearchParams(window.location.search)

    if (urlParams.get('split') === 'true') {
      ctrl.freeFormContentTarget.value = ctrl.originContentTarget.value
      ctrl.splitOriginPost(true)
    } else {
      ctrl.splitOriginPost()
    }
  }

  chunksCount() {
    var ctrl = this

    return ctrl.freeFormContentTarget.value.split(separator).length
  }

  splitOriginPost(isReset = false) {
    var ctrl = this
    var chunkWords = []
    var chunksArr = []
    var content = ctrl.freeFormContentTarget.value
    var hasChunks = ctrl.freeFormContentTarget.dataset.hasChunks
    var chunkIndex = 1
    var words = content.trim().split(/\s+/)
    var isLastWord

    if (isReset || hasChunks === 'false') {
      if (words.join(' ').length <= ctrl.charsLimit(chunkIndex)) {
        chunksArr.push(words.join(' '))
      } else {
        words.forEach(function (word, i) {
          isLastWord = words.length === i + 1

          chunkWords.push(word)

          if (chunkWords.join(' ').length > ctrl.charsLimit(chunkIndex)) {
            chunkWords.pop()
            chunksArr.push(chunkWords.join(' '))
            chunkWords = []
            chunkIndex++
            chunkWords.push(word)
            if (isLastWord) {
              chunksArr.push(chunkWords.join(' '))
            }
          } else if (isLastWord) {
            chunksArr.push(chunkWords.join(' '))
          }
        })
      }

      ctrl.freeFormContentTarget.value = chunksArr.join(separator)
    }

    ctrl.reloadChunks()
  }

  reloadChunks() {
    var ctrl = this

    ctrl.freeFormContentTarget.value.split(separator).forEach(function (chunk, index) {
      if (chunk.length > 0) {
        if (ctrl.chunkContentFieldTargets[index] != undefined) {
          ctrl.chunkContentFieldTargets[index].value = chunk
        } else {

          var dropzoneHTML =
            '<div class="mb-6" data-index="' + `${index + 1}` + '">' +
              '<div class="dropzone dropzone-default" data-controller="dropzone" data-dropzone-max-file-size="5" data-dropzone-max-files="4" data-dropzone-accepted-files="image/png,image/jpg,image/jpeg,image/gif,image/webp,video/*" data-index="' + `${index + 1}` + '">' +
                '<input data-target="dropzone.input" data-direct-upload-url="/rails/active_storage/direct_uploads" type="file" multiple="multiple" name="post_chunk_images" id="post_chunk_images" disabled="" style="display: none;">' +
              '</div>' +
            '</div>'

          var mediaUploadingClass = gon.media_uploading ? '' : 'disable tooltips'

          var newChunk = document.createElement('div')

          newChunk.innerHTML =
            '<div data-target="post-chunks.chunk" class="mt-4 mb-4">' +
              '<textarea data-index="' + index + '" data-target="post-chunks.chunkContentField" data-action="input->post-chunks#onInputChunkContentField" class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 h-40">' +
                chunk +
              '</textarea>' +
              '<div class="flex">' +
                '<div class="w-1/2 text-left"><span data-target="post-chunks.characterField"></span></div>' +
                '<div class="w-1/2 text-right">' +
                  '<div class="media-uploading ' + `${mediaUploadingClass}` + '">' +
                    '<button class="add-files" data-index="' + `${index + 1}` + '"><span class="tooltip-text bg-blue-200 p-2 -mt-6 -ml-6 rounded">Only paid users can add media</span><svg height="20" viewBox="0 -18 512 512" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m432 0h-352c-44.113281 0-80 35.886719-80 80v280c0 44.113281 35.886719 80 80 80h273c11.046875 0 20-8.953125 20-20s-8.953125-20-20-20h-73.664062l-45.984376-59.65625 145.722657-185.347656 98.097656 108.421875c5.546875 6.136719 14.300781 8.21875 22.019531 5.246093 7.714844-2.976562 12.808594-10.394531 12.808594-18.664062v-170c0-44.113281-35.886719-80-80-80zm40 198.085938-79.167969-87.503907c-3.953125-4.371093-9.640625-6.785156-15.523437-6.570312-5.886719.207031-11.386719 2.996093-15.03125 7.628906l-154.117188 196.023437-52.320312-67.875c-3.785156-4.910156-9.636719-7.789062-15.839844-7.789062-.003906 0-.007812 0-.011719 0-6.203125.003906-12.058593 2.886719-15.839843 7.804688l-44.015626 57.21875c-6.734374 8.757812-5.097656 21.3125 3.65625 28.046874 8.757813 6.738282 21.3125 5.097657 28.050782-3.65625l28.175781-36.632812 88.816406 115.21875h-148.832031c-22.054688 0-40-17.945312-40-40v-280c0-22.054688 17.945312-40 40-40h352c22.054688 0 40 17.945312 40 40zm0 0"/><path d="m140 72c-33.085938 0-60 26.914062-60 60s26.914062 60 60 60 60-26.914062 60-60-26.914062-60-60-60zm0 80c-11.027344 0-20-8.972656-20-20s8.972656-20 20-20 20 8.972656 20 20-8.972656 20-20 20zm0 0"/><path d="m468.476562 302.941406c-.058593-.058594-.117187-.121094-.175781-.179687-9.453125-9.519531-22.027343-14.761719-35.410156-14.761719-13.34375 0-25.882813 5.210938-35.324219 14.675781l-38.613281 38.085938c-7.863281 7.753906-7.949219 20.417969-.191406 28.28125 7.753906 7.863281 20.417969 7.953125 28.28125.195312l25.847656-25.492187v112.253906c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-111.644531l24.738281 25.554687c3.921875 4.054688 9.144532 6.089844 14.371094 6.089844 5.011719 0 10.027344-1.871094 13.910156-5.628906 7.9375-7.683594 8.140625-20.34375.457032-28.28125zm0 0"/></svg></button>' +
                  '</div>' +
                  '<span data-target="post-chunks.chunkIndexField" class="ml-2">' + ` /${index + 1}` + '</span>' +
                '</div>' +
              '</div>' +
              dropzoneHTML +
            '</div>'

          ctrl.dynamicChunksTarget.appendChild(newChunk)
        }
      }

      ctrl.promoChunkIndexFieldTarget.innerText = `/${ctrl.chunksCount() + 1}`

      if (ctrl.chunksCount() + ctrl.promoChunkIndexFieldTargets.length == 1) {
        ctrl.chunkIndexFieldTarget.style.visibility = 'hidden'
      } else {
        ctrl.chunkIndexFieldTargets[0].style.visibility = ''
      }
    })

    ctrl.deleteLegacyChunks()
    ctrl.reloadCharacterCounters()
  }

  deleteLegacyChunks() {
    var ctrl = this
    var legacyChunks = ctrl.chunkTargets.splice(ctrl.chunksCount())
    var confirmShown = false

    if (legacyChunks.length > 0) {
      legacyChunks.forEach(function (chunk) {
        var imagesCount = $(chunk).find('.dz-complete').length

        if (imagesCount > 0 && !confirmShown) {
          var confirmed = confirm('Images will be removed with chunks. Continue?')
          confirmShown = true

          if (confirmed) {
            chunk.remove()
          } else {
            ctrl.freeFormContentTarget.value = ctrl.prevContent
            ctrl.reloadChunks()
          }
        } else {
          chunk.remove()
        }
      })
    }
  }

  resetToOrigin() {
    var ctrl = this
    var confirmed = confirm('Do you want to reset all unsaved changes?')

    if (confirmed) {
      ctrl.freeFormContentTarget.value = ctrl.originContentTarget.value
      ctrl.splitOriginPost(true)
    }
  }

  buildFormData() {
    var ctrl = this
    var formData = new FormData()
    formData.append('post[content]', ctrl.freeFormContentTarget.value)
    formData.append('post[promo_chunk_content]', ctrl.promoChunkContentTarget.value)

    for (var i = 0; i < ctrl.chunksCount(); i++) {
      var $signedId = $(`[data-index="${i + 1}"] .signed-id`)

      $signedId.each(function (index, signed_id) {
        formData.append(`post[images][${i + 1}][]`, signed_id.value);
      })
    }

    return formData
  }

  saveDraft() {
    var ctrl = this
    var actionUrl = ctrl.freeFormContentTarget.dataset.saveDraftUrl

    ctrl.actionButtonsTarget.classList.add('hidden')
    ctrl.loaderTarget.classList.remove('hidden')

    if (!ctrl.isAllChunksValid()) {
      return
    }

    axios({
      method: 'post',
      url: actionUrl,
      headers: { 'content-type': 'multipart/form-data' },
      data: ctrl.buildFormData()
    }).then(function (response) {
        ctrl.showMessage('succes', 'Post chunks were successfully saved.')
        history.replaceState(null, null, window.location.href.replace('split=true', ''))
      })
      .catch(function (error) {
        ctrl.showMessage('error', error)
      })
      .then(function (value) {
        ctrl.actionButtonsTarget.classList.remove('hidden')
        ctrl.loaderTarget.classList.add('hidden')
      })
  }

  publishPost() {
    var ctrl = this
    var actionUrl = ctrl.freeFormContentTarget.dataset.publishPostUrl

    ctrl.actionButtonsTarget.classList.add('hidden')
    ctrl.loaderTarget.classList.remove('hidden')

    if (!ctrl.isAllChunksValid()) {
      ctrl.actionButtonsTarget.classList.remove('hidden')
      ctrl.loaderTarget.classList.add('hidden')

      return
    }

    axios({
      method: 'post',
      url: actionUrl,
      headers: { 'content-type': 'multipart/form-data' },
      data: ctrl.buildFormData()
    }).then(function (response) {
        window.location = '/'
      })
      .catch(function (error) {
        ctrl.showMessage('error', error.response.data.error)
      })
      .then(function (response) {
        ctrl.actionButtonsTarget.classList.remove('hidden')
        ctrl.loaderTarget.classList.add('hidden')
      })
  }

  reloadCharacterCounters () {
    var ctrl = this
    var chunks_length = ctrl.chunksCount() + ctrl.promoChunkIndexFieldTargets.length


    ctrl.characterFieldTargets.forEach(function(elem, index) {
      var allChunks = ctrl.chunkContentFieldTargets.concat(ctrl.promoChunkContentTarget)
      var currentLength = allChunks[index].value.length

      elem.innerText = `${currentLength}/${ctrl.charsLimit(index + 1, chunks_length)}`

      if (currentLength > ctrl.charsLimit(index + 1, chunks_length)) {
        elem.classList.add('text-red-600')
      } else {
        elem.classList.remove('text-red-600')
      }
    })
  }

  buildFreeFormFromChunks() {
    var ctrl = this

    ctrl.freeFormContentTarget.value =
      ctrl.chunkContentFieldTargets.map(function (elem) {
        return elem.value
      }).join(separator)
  }

  onKeyDownFreeForm() {
    var ctrl = this
    ctrl.prevContent = ctrl.freeFormContentTarget.value
  }

  onChangeFreeForm() {
    var ctrl = this
    ctrl.reloadChunks()
  }

  onInputChunkContentField() {
    var ctrl = this

    ctrl.buildFreeFormFromChunks()
    ctrl.reloadCharacterCounters()

    if (event.target.value.includes(separator)) {
      ctrl.reloadChunks()
    }
  }

  onInputPromoChunkContent() {
    var ctrl = this

    ctrl.reloadCharacterCounters()
  }

  isAllChunksValid() {
    var ctrl = this
    var chunks_length = ctrl.chunksCount() + ctrl.promoChunkIndexFieldTargets.length
    var allChunks = ctrl.chunkContentFieldTargets.concat(ctrl.promoChunkContentTarget)
    var invalidChunk =
      allChunks.find(function (chunk, index) {

        return chunk.value.length > ctrl.charsLimit(index + 1, chunks_length)
      })

    if (invalidChunk) {
      ctrl.showMessage('error', 'One or more chunks have over limit characters!')
      return false
    } else {
      return true
    }
  }

  showMessage(type, text) {
    var ctrl = this

    ctrl.notificationFieldTarget.classList.remove('text-red-600', 'text-green-600')

    if (type === 'error') {
      ctrl.notificationFieldTarget.classList.add('text-red-600')
    }

    if (type === 'succes') {
      ctrl.notificationFieldTarget.classList.add('text-green-600')
    }

    ctrl.notificationFieldTarget.innerText = text
  }

  charsLimit(index, chunks_length = 0) {
    var counterLenght = gon.counter_template_length + index.toString().length
    
    if (chunks_length == 1) {
      return maxLength
    }

    return maxLength - counterLenght
  }

  togglePromoChunk() {
    var ctrl = this
    var defaultPromo = 'This thread was created using @threadbetter. Simple and fast Twitter thread creation. Go to https://www.threadbetter.io to request access.'

    ctrl.promoSwitcherTarget.firstChild.classList.toggle('translate-x-0')
    ctrl.promoSwitcherTarget.classList.toggle('bg-gray-200')
    ctrl.promoSwitcherTarget.classList.toggle('bg-indigo-600')
    ctrl.promoSwitcherTarget.firstChild.classList.toggle('translate-x-5')

    if (ctrl.promoSwitcherTarget.dataset.state ==='enabled') {
      ctrl.promoSwitcherTarget.dataset.state = 'disabled'
      ctrl.promoChunkContentTarget.value = ''
      ctrl.promoChunkTarget.classList.add('hidden')
    } else {
      ctrl.promoSwitcherTarget.dataset.state = 'enabled'
      ctrl.promoChunkContentTarget.value = defaultPromo
      ctrl.promoChunkTarget.classList.remove('hidden')
    }
  }

  schedulePost(event) {
    var ctrl = this
    var target = event.currentTarget.children[0]

    target.disabled = true
    target.classList.remove('hover:bg-gray-400')
    target.classList.add('opacity-50', 'cursor-not-allowed')

    ctrl.scheduleFieldsTarget.classList.remove('hidden')
  }

  editTimeZone() {
    var ctrl = this

    ctrl.currentTimeZoneTarget.classList.add('hidden')
    ctrl.editTimeZoneButtonTarget.classList.add('hidden')
    ctrl.timeZoneFieldTarget.classList.remove('hidden')
  }
}
